import { render } from "./Weton.vue?vue&type=template&id=91f5a9de"
import script from "./Weton.vue?vue&type=script&lang=js"
export * from "./Weton.vue?vue&type=script&lang=js"

import exportComponent from "/vercel/path0/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__